import { render, staticRenderFns } from "./printPriceLabel.vue?vue&type=template&id=711b136a&scoped=true&"
import script from "./printPriceLabel.vue?vue&type=script&lang=js&"
export * from "./printPriceLabel.vue?vue&type=script&lang=js&"
import style0 from "./printPriceLabel.vue?vue&type=style&index=0&id=711b136a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711b136a",
  null
  
)

export default component.exports